<i18n locale="en">
{
  "title": "Generated Alternatives"
}
</i18n>

<template>
  <div class="image-gallery-panel">
    <OwnType
      :text="t('title')"
      variant="title-small"
      color="primary"
      class="mb-3"
    />
    <ImageGalleryGrid
      :items="items"
      @item-click="$emit('item-click', $event)"
      @placeholder-click="$emit('generate-click')"
      @item-retry="$emit('item-retry', $event)"
    />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { OwnType } from '@/ui/OwnType'

import ImageGalleryGrid from './ImageGalleryGrid.vue'
import type { GalleryItem } from './types'

const { t } = useI18n()

interface Props {
  items: GalleryItem[]
}

interface Emits {
  (event: 'item-click', item: GalleryItem): void
  (event: 'generate-click'): void
  (event: 'item-retry', item: GalleryItem): void
}

defineProps<Props>()
defineEmits<Emits>()
</script>

<style lang="scss" scoped>
.image-gallery-panel {
  width: 100%;
}
</style>
